<script>
import lazyLoadComponent from '@router/lazyload-component'
import analyticsDateValidateMixin from '@src/mixins/analyticsDateValidateMixin'
import pageMixin from '@src/mixins/pagination'
import formatDate, { formatRequestData } from '@utils/format-date'
import { defaultStatusFilter, numberUnitFilter } from '@utils/filter-value-to-text'
import { merchantUserComputed } from '@state/helpers'
import { debounce } from 'lodash'
import productMixin from '@/src/mixins/product'

export default {
  page: {
    title: '數據分析',
    meta: [{ name: 'description', content: 'Customer Analytics' }],
  },
  filters: {
    defaultStatusFilter,
    numberUnitFilter,
  },
  components: {},
  mixins: [pageMixin, productMixin, analyticsDateValidateMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterData: {
        startDate: '',
        endDate: '',
        jobTitle: '',
        userGroupId: '',
        scheduleItemName: '',
        block: null,
        unit: 'week',
        productId: '',
      },
      staffs: [],
      columnShowList: ['姓名', '接單數量', '訂單累計金額', '接單累計金額', '排班時數', '服務分潤', '業績分潤' ],
      dateRangeMode: 'month',
      dateNow: '',
      activeCellData: '',
      tryingFetch: false,
      tryingFetchTime: false,
      tryingToExport: false,
      productList: [],
      remarkOptions: [
        {label: '姓名'}, 
        {label: '接單數量'}, 
        {label: '訂單累計金額'}, 
        {label: '接單累計金額'}, 
        {label: '排班時數'}, 
        {label: '服務分潤'}, 
        {label: '業績分潤'}, 
        {label: '新客數量'}, 
        {label: '新客購買數'}, 
        {label: '新客成交率'}
      ],
    }
  },
  computed: {
    // ...authComputed,
    ...merchantUserComputed,
    filterDateRange: {
      get() {
        return [this.filterData.startDate, this.filterData.endDate]
      },
      set(value) {
        const [start, end] = value || ['', '']
        this.filterData.startDate = start
        this.filterData.endDate = end
      },
    },
    fetchDataParams() {
      const routeQuery = this.$route.query
      const queryData = Object.assign(routeQuery, this.pageQuery)
      const { startDate, endDate, ...filterDataWithoutDate } = this.filterData
      const searchWithDate = startDate && endDate
      const searchParams = searchWithDate
        ? Object.assign(this.filterData, {
          startDate: formatRequestData(startDate),
          endDate: formatRequestData(endDate),
        })
        : filterDataWithoutDate
      return Object.assign(searchParams, queryData)
    },
  },
  watch: {
    filterDateRange(value) {
      if (this.filterDateRange[0] === undefined) {
        this.dateRangeMode = ''
        return
      }
      const time = (new Date(this.filterDateRange[1]).getTime() / 1000 - new Date(this.filterDateRange[0]).getTime() / 1000) / 86400
      const todayRange = Math.floor(new Date().getTime() / 1000 / 86400) - new Date(this.filterDateRange[0]).getTime() / 1000 / 86400
      switch (true) {

        case time >= 0 && time <= 7:
          this.dateRangeMode = 'day'
          this.filterData.unit = 'day'
          break
        case time > 7 && time < 30:
          this.dateRangeMode = 'week'
          this.filterData.unit = 'day'
          break
        case time >= 30 && time < 364:
          this.dateRangeMode = 'month'
          this.filterData.unit = 'week'
          break
        case time >= 365:
          this.dateRangeMode = 'year'
          this.filterData.unit = 'quarter'
          break

      }
      switch (true) {
        case todayRange === 0:
          this.dateNow = 'day'
          break
        case todayRange === 30:
          this.dateNow = 'month'
          break
        default:
          this.dateNow = ''
      }
    },
  },
  created() {
    this.$store.dispatch('merchant/fetchUserGroups')
    this.getDefaultDate()
    this.tryToFetchList()
    this.tryToSearchProduct()
  },
  methods: {
    async tryToSearchProduct() {
      const { items } = await this.$store.dispatch('product/fetchList', { limit: 10000, page: 1, paginate: 0 })
      this.productList = items
      this.productList = this.filterProductInMixin(this.productList)
    },
    getDefaultDate() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.filterData.startDate = `${start.getFullYear()}/${start.getMonth() + 1}/${start.getDate()}`
      this.filterData.endDate = `${end.getFullYear()}/${end.getMonth() + 1}/${end.getDate()}`
    },
    async tryToFetchList() {
      if (this.filterDateRange[0] === undefined) {
        this.dateRangeMode = ''
      }
      this.tryingFetch = true
      this.tryingFetchTime = true
      this.staffs = await this.$store.dispatch('analytics/fetchScheduleItem', this.fetchDataParams)
      this.tryingFetch = false
      this.tryingFetchTime = false
    },
    async tryToFetchListUnit() {
      this.tryingFetchTime = true
      this.staffs = await this.$store.dispatch('analytics/fetchScheduleItem', this.fetchDataParams)
      this.tryingFetchTime = false
    },
    reset() {
      // this.filterDateRange = []
      // this.dateRangeMode = 'month'
      // this.filterData.unit = 'week'
      this.getDefaultDate()
      this.tryToFetchList()
    },

    changeCellClass(row, column, rowIndex, columnIndex) {
      if (row.column.label === this.activeCellData) {
        return 'active'
      } else {
        return ''
      }
    },
    isField(type) {
      return this.columnShowList.includes(type)
    },
    async handleExport() {
      if (this.tryingToExport) return
      this.tryingToExport = true
      const request = {
        analyticsType: 'scheduleItem',
        submitData: {
          ...this.fetchDataParams,
          export: 1,
        },
      }
      const { fileName, csvData } = await this.$store.dispatch('analytics/analyticsExport', request)
      const csvFormatData = csvData.map((row) => Object.values(row).join(',')).join('\n')
      const blob = new Blob(['\uFEFF', csvFormatData], {
        type: 'text/csv;charset=utf-8;',
      })
      const url = window.URL.createObjectURL(blob)
      const date = `${this.filterDateRange[0]} 至 ${this.filterDateRange[1]}`
      let jobTitle = ''
      let userGroupTitle = ''
      let statustitle = ''
      let scheduleItemName = ''

      if (this.fetchDataParams.jobTitle) {
        jobTitle = ` ${this.fetchDataParams.jobTitle}`
      }
      if (this.fetchDataParams.userGroupId) {
        userGroupTitle = this.userGroupList.find((item) => {
          return item.id === this.fetchDataParams.userGroupId
        }).title
        userGroupTitle = ` ${userGroupTitle}`
      }
      if (this.fetchDataParams.block !== null) {
        statustitle = this.fetchDataParams.block === 0 ? '啟用' : '停權'
        statustitle = ` 狀態：${statustitle}`
      }
      if (this.fetchDataParams.scheduleItemName) {
        scheduleItemName = ` ${this.fetchDataParams.scheduleItemName}`
      }
      const filterFileName = `${fileName} ( ${date}${jobTitle}${userGroupTitle}${statustitle}${scheduleItemName} ).csv`
      const tempLink = document.createElement('a')
      tempLink.download = filterFileName
      tempLink.href = url
      tempLink.click()
      window.URL.revokeObjectURL(url)
      this.tryingToExport = false
    },
    tryToSearchByInput: debounce(function () {
      this.tryToFetchList()
    }, 300),
    quickSelectTime(unit) {
      if (unit === 'day') {
        const end = new Date()
        const start = new Date()
        this.filterDateRange = [start, end]
      }
      if (unit === 'month') {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.filterDateRange = [start, end]
      }
      this.tryToFetchList()
    }
  },
}
</script>

<template>
  <div>
    <div class="btn-top-space-between local_topBtn">
      <el-button class="is-round" plain @click="handleExport">
        <BaseIcon name="file-export" /> 訂單匯出
      </el-button>
    </div>
    <BaseTableSearch v-slot="{ fields }" hide-action :default-value.sync="filterData" class="isForTab2" @reset="reset"
      @tryToFetchList="tryToFetchList" :growStatus="true" reset-btn-style="width:84px;height:44px;">
      <el-form-item v-if="userGroupList.length > 0">
        <el-select v-model="fields.userGroupId" placeholder="帳號權限" @change="tryToFetchList">
          <el-option label="所有權限" value></el-option>
          <el-option v-for="item in userGroupList" :key="item.id" :value="item.id" :label="item.title"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="fields.block" placeholder="狀態" @change="tryToFetchList">
          <el-option :label="'全部狀態'" :value="null"></el-option>
          <el-option :label="'啟用'" :value="0"></el-option>
          <el-option :label="'停權'" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="filterData.productId" placeholder="選擇分店" class="is-border is-round" @change="tryToFetchList">
          <el-option label="所有分店" value></el-option>
          <el-option v-for="(product, index) in productList" :key="`product-${index}`" :label="product.name"
            :value="product.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="filterDateRange" type="daterange" align="left" unlink-panels range-separator="-"
          start-placeholder="起始日期" end-placeholder="結束日期" :picker-options="pickerOptions" style="width:405px"
          :clearable="false" @change="tryToFetchListFromDatePicker"></el-date-picker>
      </el-form-item>
    </BaseTableSearch>
    <div class="centerTextRadio" :class="$style.bgWhite">
      <h4>銷售紀錄</h4>
      <el-popover placement="bottom-end" width="250" trigger="click" popper-class="isStyleField">
        <div class="mb-3">欄位顯示：</div>
        <el-checkbox-group v-model="columnShowList">
          <el-checkbox v-for="item in remarkOptions" :key="item.label" :label="item.label"> </el-checkbox>
        </el-checkbox-group>
        <el-button slot="reference" class="isStyleField is-round w-100">
          <BaseIcon name="calendar-edit" />
          欄位顯示
          <BaseIcon name="angle-down" />
        </el-button>
      </el-popover>
    </div>

    <div class="el-table-wrapper" style="padding: 0 20px 20px;">
      <el-table v-loading="tryingFetchTime" element-loading-text="取得資訊中" :data="staffs"
        :cell-class-name="changeCellClass" :header-cell-class-name="changeCellClass">
        <el-table-column v-if="isField('姓名')" v-slot="{ row }" label="姓名" min-width="80">
          <div>{{ row.name }}</div>
        </el-table-column>
        <el-table-column v-if="isField('接單數量')"  label="接單數量" align="right" min-width="120" prop="ordersCount" sortable> </el-table-column>
        <el-table-column v-if="isField('訂單累計金額')" v-slot="{ row }" label="訂單累計金額" align="right" min-width="150" sortable>
          美容師: NT${{ row.actualTotal }} <br />
          助理:NT${{ row.helperActualTotal }}
        </el-table-column>
        <el-table-column v-if="isField('接單累計金額')" v-slot="{ row }" label="接單累計金額" align="right" min-width="150" prop="actualTotal" sortable>
          美容師: NT${{ row.ordersTotal }} <br />
          助理:NT${{ row.helperOrdersTotal }}
        </el-table-column>
        <el-table-column v-if="isField('排班時數')" label="排班時數" min-width="120" align="right" prop="scheduleTotalHours" sortable>
        </el-table-column>
        <el-table-column v-if="isField('服務分潤')" v-slot="{ row }" label="服務分潤" align="right" min-width="120" prop="skillTotal" sortable>
          NT${{ row.skillTotal }}
        </el-table-column>
        <el-table-column v-if="isField('業績分潤')" v-slot="{ row }" label="業績分潤" align="right" min-width="120" prop="performanceTotal" sortable>
          NT${{ row.performanceTotal }}
        </el-table-column>
        <el-table-column v-if="isField('新客數量')" v-slot="{ row }" label="新客數量" align="right" min-width="120" prop="firstOrderMemberCount" sortable>
          {{ row.firstOrderMemberCount }}
        </el-table-column>
        <el-table-column v-if="isField('新客購買數')" v-slot="{ row }" label="新客購買數" align="right" min-width="140" prop="firstOrderMemberPrepaidOrderCount" sortable>
          {{ row.firstOrderMemberPrepaidOrderCount }}
        </el-table-column>
        <el-table-column v-if="isField('新客成交率')" v-slot="{ row }" label="新客成交率" align="right" min-width="140" prop="firstOrderMemberConversionRate" sortable>
          {{ row.firstOrderMemberConversionRate }}
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>
<style lang="scss" module>
.bottomInfo {
  text-align: center;
  padding: 30px 0;

  :global {
    .bottomInfo {
      &__item {
        padding: 0 10px;
      }
    }
  }
}

.bgWhite {
  background-color:white ;
  &.lessMargin{
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
